import { FrenzyLine, Point } from "../Model"
import { areSame } from "../utils/Point"

export type FrenzyPointVisitor<T> = (point:Point) =>  T | undefined;

export type LinePointVisitorSuccess<T> = {
  result: T
  foundAt: Point
}

export type LinePointVisitorFailure = {
  lineEndPoint: Point
}

export type LinePointVisitorResult<T> = LinePointVisitorSuccess<T> | LinePointVisitorFailure

export function isFailure<T>(visitorResult: LinePointVisitorResult<T>): visitorResult is LinePointVisitorFailure {
  return (visitorResult as LinePointVisitorFailure).lineEndPoint !== undefined;
}

/** Normalise the direction and get to the other end of the line, calling the visitor on each point */
export function visitEachPointOnLine<T>(line: FrenzyLine, startPoint: Point, visitorFn: FrenzyPointVisitor<T>): LinePointVisitorResult<T>{
  if (areSame(line.start, startPoint)) {
    // traverse from start-> end
    const endPoint = line.end;
    for (let newPoint = line.start; !areSame(newPoint,endPoint); newPoint = line.direction.traverseFromPoint(newPoint)) {
      const result = visitorFn(newPoint);
      if (result) {
        return { result, foundAt: newPoint};
      }      
    }  
    const result = visitorFn(endPoint); // last chance
    if (result) {
      return { result, foundAt: endPoint};
    } else {
      return { lineEndPoint: endPoint}
    } 
  } else {
    // traverse from end-> start
    for (let newPoint = line.end; !areSame(newPoint,line.start); newPoint = line.direction.reverseFromPoint(newPoint)) {
      const result = visitorFn(newPoint);
      if (result) {
        return { result, foundAt: newPoint};
      }      
    }  
    const result = visitorFn(line.start); // last chance
    if (result) {
      return { result, foundAt: line.start};
    } else {
      return { lineEndPoint: line.start}
    } 
  }
}